import { injectable, inject } from 'inversify';
import JsonRpcDispatcher, { interceptors } from '@dealroadshow/json-rpc-dispatcher';
import evercallUrl from '@evercall/url';
import addSessionData from '@users/session/interceptors/rpc/addSessionData';
import checkSession from '@users/session/interceptors/rpc/checkSession';
import parseWrappedError from '@framework/api/Rpc/parseWrappedError';
import Container from '@framework/di/Container';
import OTelInstrument from '@framework/otel/OTelInstrument';
import DITypes from './DI/types';
import type { IAdapterFactory } from './DI/interfaces';

@injectable()
export class WebServiceRpcDispatcher extends JsonRpcDispatcher {
  constructor(
    @inject(Container) readonly container: Container,
    @inject(DITypes.AdapterFactory) readonly adapterFactory: IAdapterFactory,
  ) {
    super(adapterFactory.create(evercallUrl.getWebServiceRpcUrl(), { otelPropagation: false }));

    this.interceptRequest(addSessionData(container))
      .interceptResponse(checkSession(container))
      .interceptResponse(parseWrappedError())
      .interceptResponse(interceptors.response.transformErrorToException);

    OTelInstrument<typeof this.call>(
      this,
      'call',
      container,
      (request) => `rpc.call: ${ request.method }`,
      (request) => {
        return {
          attributes: {
            'rpc.method': request.method,
          },
        };
      },
    );
  }
}
